// extracted by mini-css-extract-plugin
export default {"root":"NotificationDate_root__dq1Ai"};